import React from 'react'
import deepcopy from 'lodash.clonedeep'
import loadable from '@loadable/component'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import { contentAreaIds, contentAreaTypes } from '../config'

const CMS = loadable.lib(() => import(/* webpackChunkName: "cms-components" */ '@sainsburys-tech/bolt-cms-components'))

class CategoryListerContentHelper {
  static isGridLayoutThree(contentArea) {
    return !!contentArea && contentArea.type === contentAreaTypes.GridLayoutThree
  }

  static injectNavigationComponent(contentArea, categoryChildren, onFindabilityClick, alwaysShowNavigation = false) {
    contentArea.navigation = [
      {
        type: contentAreaTypes.NavigationComponent,
        children: categoryChildren,
        alwaysShowNavigation
      }
    ]
    contentArea.onLinkClick = onFindabilityClick
  }

  static injectGridLayoutThreeComponent(area) {
    area.attributes = [{ type: contentAreaTypes.GridLayoutThree }]
  }

  static injectArtificialOffersArea(contentAreas) {
    const areas = deepcopy(contentAreas)
    areas.push({ id: contentAreaIds.AreaD, artificialOffersArea: true })
    return areas
  }

  static injectMerchAreaFullWidthComponent(area) {
    area.attributes.push({ type: contentAreaTypes.BackgroundHeading })
  }

  static isOffersArea(area) {
    return area.id === contentAreaIds.AreaD
  }

  static isPrimaryMerchArea(area) {
    return area.id === contentAreaIds.AreaB
  }

  static containsBackgroundImageComponent(area) {
    return area.attributes
      ? area.attributes.some(component => component.type === contentAreaTypes.BackgroundImageGrid)
      : false
  }

  static mergeDfpAreaConfig(area, dfpParams) {
    if (area) {
      return { ...dfpParams, ...area }
    }
  }

  static isDfpArea(area) {
    return area.id === contentAreaIds.Dfp.top || area.id === contentAreaIds.Dfp.bottom
  }

  static isOffersAreaEmpty(area) {
    return !area.attributes || !area.attributes.length
  }

  static getContentAreas(
    contentAreas,
    topLevelCategoryId,
    categoryChildren,
    onFindabilityClick,
    dfpParams,
    categoryName
  ) {
    const areas = deepcopy(contentAreas)
    const contentComponents = []
    !!areas &&
      areas.forEach(area => {
        if (this.isOffersArea(area) && this.isOffersAreaEmpty(area)) {
          this.injectGridLayoutThreeComponent(area)
        }
        if (
          !this.containsBackgroundImageComponent(area) &&
          this.isPrimaryMerchArea(area) &&
          area.attributes.length >= 1
        ) {
          this.injectMerchAreaFullWidthComponent(area)
        }
        !!area.attributes &&
          area.attributes.forEach((currentArea, j) => {
            if (this.isGridLayoutThree(currentArea)) {
              this.injectNavigationComponent(
                currentArea,
                categoryChildren,
                onFindabilityClick,
                area.artificialOffersArea
              )
            }
            if (currentArea.type) {
              const contentProps = !this.isDfpArea(area)
                ? {
                    ...currentArea,
                    categoryId: topLevelCategoryId,
                    onLinkClick: currentArea.onLinkClick || onFindabilityClick
                  }
                : { ...this.mergeDfpAreaConfig(currentArea, dfpParams), areaId: area.id }
              contentComponents.push(
                <div key={`${j + area.id + categoryName}`} data-area={`${j + area.id}`}>
                  <ErrorBoundary>
                    <CMS>
                      {({ GetComponent }) => {
                        return <GetComponent {...{ ...currentArea, ...contentProps }} />
                      }}
                    </CMS>
                  </ErrorBoundary>
                </div>
              )
            }
          })
      })
    return contentComponents
  }
}

export default CategoryListerContentHelper
